import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  createHashHistory,
  createRouter,
  RouterProvider,
} from "@tanstack/react-router";
import "./index.css";
import { routeTree } from "./routeTree.gen";

import { debug } from "./utils/debug";

// Debug logging for production builds
debug.log("Application starting...");
debug.log("Router configuration:", routeTree);
const router = createRouter({ routeTree, history: createHashHistory() });
// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
// Log the target element
const targetElement = document.getElementById("accessibility-plus-app");
debug.log("Target element:", targetElement);

if (!targetElement) {
  debug.error("Target element #accessibility-plus-app not found!");
  throw new Error("Target element #accessibility-plus-app not found!");
}

if (!targetElement.innerHTML) {
  const root = createRoot(targetElement);
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
